import {h} from 'preact';
import StateSelect from '../StateSelect';

// function() {
//     $(this).addClass('disabled');
//     var params = {
//         'requestId': reqObj.requestId,
//         'prop.address': $('[name="req.prop.address"]').val(),
//         'prop.city': $('[name="req.prop.city"]').val(),
//         'prop.state': $('[name="req.prop.state"]').val(),
//     };
//     $.post('updateFidelityOwner-json', $.param(params)).then(function(data) {
//         defaultAjaxError(data.msg);
//     });
// }

const SellPropertyForm = ({
    prop,
    lowRange,
    highRange,
    submitting,
    saveProperty,
    editingRequestInfo,
    highZestimate,
    owner
}) => {
    function refreshTitle() {
        var params = {
            'requestId': reqObj.requestId,
            'prop.address': prop.address,
            'prop.city': prop.city,
            'prop.state': prop.state
        };
        $.post('updateFidelityOwner-json', $.param(params)).then(function(data) {
            defaultAjaxError(data.msg);
            saveProperty();
        });
    }

    return (
        <div className={`card property-form ${editingRequestInfo ? '' : 'hidden'}`}>
            <div className="row account-form-rows">
                <div className="col-md-4 form-group user-account-form-rows adminFlagCommentSection">
                    <label>Property Type</label>
                    <select id="home-type-dropdown" className="form-control custom-select" name="req.prop.homeType">
                        {!prop.homeType && <option value="">Please select</option>}
                        <option value="Single Family" selected={prop.homeType === 'Single Family' ? 'selected' : ''}>
                            Single Family
                        </option>
                        <option
                            value="Townhouse"
                            selected={prop.homeType === 'Townhouse' ? 'selected' : ''}>
                            Townhouse
                        </option>
                        <option value="Multi-Family" selected={prop.homeType === 'Multi-Family' ? 'selected' : ''}>
                            Multi-Family
                        </option>
                        <option value="Condominium" selected={prop.homeType === 'Condominium' ? 'selected' : ''}>
                            Condominium
                        </option>
                        <option value="Land" selected={prop.homeType === 'Land' ? 'selected' : ''}>
                            Vacant Lot/Other
                        </option>
                        <option value="Commercial" selected={prop.homeType === 'Commercial' ? 'selected' : ''}>
                            Commercial
                        </option>
                    </select>
                    <i className="fa fa-angle-down"></i>
                </div>
                <div id="col-md-address" className="col-md-8 form-group user-account-form-rows">
                    <label>Address</label>
                    <input className="form-control" name="req.prop.address" type="text" value={prop.address} />
                </div>
            </div>

            <div className="row account-form-rows">
                <div className="col-md-4 form-group user-account-form-rows">
                    <label>City</label>
                    <input className="form-control" type="text" name="req.prop.city" value={prop.city} />
                </div>
                <div className="col-md-4 form-group user-account-form-rows">
                    <label>State</label>
                    <StateSelect
                        className="form-control"
                        type="text"
                        name="req.prop.state"
                        maxLength={2}
                        value={prop.state ? prop.state : ''}
                    />
                </div>
                <div className="col-md-4 form-group user-account-form-rows">
                    <label>Zipcode</label>
                    <input
                        className="form-control zipcodeUS"
                        type="number"
                        name="req.prop.zip"
                        maxLength={5}
                        minLength={5}
                        value={prop.zip}
                    />
                </div>
            </div>

            <div className="row account-form-rows">
                <div className="col-md-4 form-group user-account-form-rows">
                    <label>Number of Bedrooms</label>
                    <input className="form-control" type="number" name="req.prop.beds" value={prop.beds} />
                </div>
                <div className="col-md-4 form-group user-account-form-rows">
                    <label>Number of Baths</label>
                    <input className="form-control" type="number" step="0.5" name="req.prop.baths" value={prop.baths} />
                </div>
                <div className="col-md-4 form-group user-account-form-rows">
                    <label>Estimate</label>
                    <input className="form-control" type="number" name="req.zestimate" value={highZestimate} min={100_000} />
                </div>
            </div>

            <div className="row account-form-rows ">
                <div className="col-xs-12">
                    <label>Title:</label>
                    <div>
                        {owner ? owner : 'No title found, please check the address'}
                        <div className="btn button-custom small blue outline rounded" onClick={refreshTitle}>
                            Refresh
                        </div>
                    </div>
                </div>
            </div>

            <div className="row account-form-rows adminFlagCommentSection toggle-row">
                <div className="col-md-4 form-group user-account-form-rows">
                    <label>How much is your home worth?</label>
                    <div>
                        <input
                            className="form-control price-range left"
                            type="text"
                            name="req.lowRange"
                            value={lowRange}
                        />
                        <span className="dash">--</span>
                        <input
                            className="form-control price-range right"
                            type="text"
                            name="req.highRange"
                            value={highRange}
                        />
                    </div>
                </div>
            </div>
            <div className="actions-container row">
                <div className={`btn orange rounded ${submitting ? 'saving' : ''}`} onClick={saveProperty}>
                    Save Changes
                </div>
            </div>
        </div>
    );
};

export default SellPropertyForm;
